import moduleAuthentication from './authentication';
import moduleBim360 from './bim-360';
import moduleDataManagement from './data-management';
import moduleModelDerivative from './model-derivative';

export default {
  namespaced: true,
  modules: {
    authentication: moduleAuthentication,
    bim360: moduleBim360,
    dataManagement: moduleDataManagement,
    modelDerivative: moduleModelDerivative,
  },
};
